import script from "./ConverzaChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConverzaChat.vue?vue&type=script&setup=true&lang=ts"

import "./ConverzaChat.vue?vue&type=style&index=0&id=382fd7cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-382fd7cc"]])

export default __exports__